import { InjectionToken } from '@angular/core';

export const HW_SERVICE_MOCK = new InjectionToken<boolean>('HW_SERVICE_MOCK');

export enum PortraitServiceState {
  Ready,
  Closed,
}
export enum CameraServiceState {
  Ready,
  Closed,
}
export enum FingerPrintsServiceState {
  Ready,
  Closed,
}
export enum PassportReaderServiceState {
  Ready,
  Closed,
}
export enum CameraType {
  Back,
  Front,
  Primary,
}
export enum SettingsServiceState {
  Ready,
  Closed,
}
export enum BatteryState {
  // Неизвестно
  Unknown,

  // Отсутствует
  Absent,

  // Питание подключено, батарея полная
  Full,

  // Питание подключено, батарея заряжается
  Charging,

  // Питание подключено, батарея НЕ заряжается
  NotCharging,

  // Питание НЕ подключено, батарея разряжается
  Discharging,
}
export enum CryptoServiceState {
  Ready,
  Closed,
}

export enum CsumStatus {
  Valid,
  Invalid,
  NotChecked,
}

export class CameraProfileItem {
  name: string;
  value: number;
}

export class SizeInfo {
  public get area() {
    return this.width * this.height;
  }

  public isAreaNear(bestArea: number, threshold: number) {
    return this.area / bestArea > 1 - threshold && this.area / bestArea < 1 + threshold;
  }

  public constructor(public readonly width: number, public readonly height: number, public readonly format: string | null) {}
}

export class CameraInfo {
  public constructor(public id: number, public type: CameraType, public frames: SizeInfo[]) {}
}

export class EyePositionInfo {
  public left: Position;
  public right: Position;
}

export class Position {
  public constructor(x: number, y: number) {
    this.x = x;
    this.y = y;
  }

  public x: number;
  public y: number;

  public copy(): Position {
    return new Position(this.x, this.y);
  }

  public equals(that: Position): boolean {
    return this.x === that.x && this.y === that.y;
  }
}

export class PhotoProcessingResult {
  public chipPhoto: Blob | null = null;
  public portraitPhoto: Blob | null = null;
  public quality: number;
}

export class FpScannerInfo {
  public id: number | null = null;
  public tag: string | null = null;
  constructor(id: number | null, tag: string | null) {
    this.id = id;
    this.tag = tag;
  }
}

export class CertInfo {
  begin: string;
  end: string;
  errorBefore: boolean;
  errorAfter: boolean;
  warningAfter: boolean;
}

export class BatteryInfo {
  capacity: number;
  state: BatteryState;
}

export class IntegrityInfo {
  valid: boolean;
  csums: string[];
  csums_status: CsumStatus[];
  messages: string[];
}
